"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreuiHeaderSideBarToggle = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const CoreuiHeaderSideBarToggleComponent = ({ toggleClass, buttonClass, }) => {
    const onClick = () => document.getElementsByClassName('app')[0].classList.toggle(toggleClass);
    return (react_1.default.createElement("button", { className: `CoreuiHeaderSideBarToggleComponent ${buttonClass}`, type: "button", onClick: onClick },
        react_1.default.createElement("span", { className: "navbar-toggler-icon" })));
};
CoreuiHeaderSideBarToggleComponent.propTypes = {
    toggleClass: prop_types_1.default.string.isRequired,
    buttonClass: prop_types_1.default.string.isRequired,
};
exports.CoreuiHeaderSideBarToggle = CoreuiHeaderSideBarToggleComponent;
//# sourceMappingURL=CoreuiHeaderSideBarToggle.js.map